<script>
  import { getTitle } from '@/ui/helpers/formTranslationsHelper';
  import { useBuilderMode } from '@/ui/concerns/checklist/useBuilderMode';

  export default {
    name: 'ConductInspectionItemSection',
    props: {
      entities: {
        type: Object,
        required: true,
      },
      item: {
        type: Object,
        required: true,
      },
      previewMode: {
        type: [Boolean, String],
        default: false,
      },
    },
    setup() {
      const { isTranslationMode } = useBuilderMode();

      return {
        isTranslationMode,
      };
    },
    computed: {
      title() {
        return getTitle(this.item, this.isTranslationMode);
      },
    },
    // this is needed to make sure circular references work WITHOUT dynamic imports (that create a lot of chunks)
    beforeCreate() {
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      this.$options.components.ConductInspectionItem = require('@/_legacy/components/ConductInspection/ConductInspectionItem.vue').default;
    },
  };
</script>

<template>
  <div
    class="preview__section"
    :class="{ repeatable: item.repeat, repeated: item.repeated }"
  >
    <div class="mb-6">
      <h1>
        <span v-if="item.required" class="text-red">*</span>
        <span>{{ title }}</span>
      </h1>
      <button
        v-if="item.repeat"
        class="btn btn-default btn-secondary"
        @click="$emit('duplicateSection', item.uuid)"
      >
        {{ $t('Add {section}', { section: title }) }}
      </button>
      <button
        v-if="item.repeated"
        class="btn btn-default btn-secondary"
        @click="$emit('deleteSection', item.uuid)"
      >
        {{ $t('Delete {section}', { section: title }) }}
      </button>

      <div
        v-if="item.errors"
        class="error-text mt-2 text-red"
      >
        {{ item.errors.join(', ') }}
      </div>
    </div>

    <template v-if="!item.repeat">
      <ConductInspectionItem
        v-for="item in entities.items[item.uuid].items"
        :key="item"
        :item="entities.items[item]"
        :entities="entities"
        :preview-mode="previewMode"
        v-on="$listeners"
      />
    </template>
  </div>
</template>

<style scoped>
.preview__section > div > h1 {
  @apply font-semibold text-2xl mb-4;
}
</style>
